import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IAddCompanyToWishListPayload } from '@app-store/slices/wishLists/addCompany'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IAddCompanyToWishListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.wishLists.addCompany

function* addCompanyWishListsSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/companies/wish-lists/add-company/${payload.id}`, { ...payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
            // yield put(rootActions.wishLists.oneWishList.onRequest({ id: payload.id }))
            notification.success({
                message: 'Companies have been added to your wishlist successfully.'
            })
            if (payload?.sagaCB) {
                payload?.sagaCB?.onSuccess(response.result)
            }
        } else {
            yield put(onFailure(''))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* addCompanyWishListsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, addCompanyWishListsSagaTask)
}

export default addCompanyWishListsSaga
